import React, { useState } from "react";
import error from "../../assets/images/error.svg";
import exit from "../../assets/images/exit.svg";

const ErrorPopUp = (props) => {
	const {
		t,
		openErrorPopUp,
		setOpenErrorPopUp,
		errorGetPaymentData,
		text,
		paymentDataAfterPayment,
		errorLoginHandler,
	} = props;

	const [close, setClose] = useState(false);
	const handleClose = () => {
		if (openErrorPopUp) {
			setClose(true);
			setOpenErrorPopUp(false);
		} else {
			setClose(false);
		}
	};

	return (
		<div>
			{!close ? (
				<div className="hover_bkgr_terms_container_prof popup_open">
					<div className="simple-popup">
						<div className="simple-popup-content simple-popup-content-confirm">
							<span className="modalTitle">{t("errorPage")}</span>
							<div className="paymentContent firstElement">
								<div className="paymentMethod">
									<div className="modalDetails firstElement withMaxWidth withBgWhite withPadding deviceSingle withSpacing modalText modalTextWithIcon">
										<div className="modalText textCenter withoutMargin">
											<div className="modalTextWithIcon">
												<img src={error} alt={t("error")} />
												{Array.isArray(text) ? (
													<div>
														<div id="top-up-confirmation-fail">{text[0]}</div>
														<br />
														<div id="top-up-confirmation-fail">
															<div style={{ fontWeight: "bold" }}>
																{text[1]}
															</div>
															{text[2]}
														</div>
													</div>
												) : (
													<div id="top-up-confirmation-fail">{text}</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
							{!errorLoginHandler ? (
								<img
									src={exit}
									className="close"
									alt={t("close")}
									onClick={() => {
										if (
											(paymentDataAfterPayment &&
												paymentDataAfterPayment.success === false) ||
											errorGetPaymentData
										) {
											window.location.href = "/";
											handleClose();
										} else {
											handleClose();
										}
									}}
								/>
							) : null}
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ErrorPopUp;
